import React from "react";
import { Card, Switch } from "antd";

const FeaturesSettings = ({ widget, handleWidgetChange }) => {
  const handleChange = (e, label) => {
    handleWidgetChange({ [label]: e, id: widget.id });
  };

  return (
    <Card className="setting_wrapper">
      <h4 className="p-color">Features Settings</h4>

      <ul className="switch_lst">
        <li>
          <Switch
            id="custom-switch"
            name="pre_chat_form"
            onChange={(e) => handleChange(e, "emoji")}
            defaultChecked={widget?.emoji}
            checked={widget?.emoji}
          />
          <span>Disable emoji selection</span>
        </li>

        <li>
          <Switch
            id="custom-switch"
            name="pre_chat_form"
            onChange={(e) => handleChange(e, "file")}
            defaultChecked={widget?.file}
            checked={widget?.file}
          />
          <span>Disable file upload</span>
        </li>

        <li>
          <Switch
            id="custom-switch"
            name="pre_chat_form"
            onChange={(e) => handleChange(e, "feedback")}
            defaultChecked={widget?.feedback}
            checked={widget?.feedback}
          />
          <span>Disable feedback</span>
        </li>

        <li>
          <Switch
            id="custom-switch"
            name="pre_chat_form"
            onChange={(e) => handleChange(e, "transcript")}
            defaultChecked={widget?.transcript}
            checked={widget?.transcript}
          />
          <span>Disable email transcript</span>
        </li>
      </ul>
    </Card>
  );
};

export default React.memo(FeaturesSettings);
